import { render, staticRenderFns } from "./Scormhomepage.vue?vue&type=template&id=69cbfc06&"
import script from "./Scormhomepage.vue?vue&type=script&lang=js&"
export * from "./Scormhomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports